import { ALL, COLUMN_NAME_MAP_DB_COLUMN_NAME, ENTITY_PRIORITY, MetaData, updateLabelMappings, updateMetaData, ID_MAP_API_REQUEST_FIELD, labelMappings, CHANNEL_NAME_MAP_CHANNEL_CODE, COLUMN_NAME_MAP_DB_COLUMN_NAME_FOR_VALID_OUTLET, ID_MAP_EXTRA_FIELDS, POST_NULL_CHECKS, POST_SchemeLocationBifurcationsList_CHECKS, POST_SchemeOutletBifurcationsList_CHECKS, POST_SchemeProductBifurcationsList_CHECKS, POST_SLAB_INFO_CHECKS, COUPON_TYPE_OPTIONS_VALUE, inPlaygroundMode, couponTitlePrefix, updateEntityPriorities } from "../utils/utils"
import { ChannelkartNetworkGet, ChannelkartNetworkPost, ChannelkartNetworkPatch} from "../../../services/networkService"
import store from "../../../stateManagement/store"
import { getMetaDataConfig } from "../../../services/uiConfigService"
import { cacheSchemePlayGroundReduxState, setALLPRODUCTS, cloneWholeScheme } from "../../../stateManagement/actions/manageCouponActions"
import { deepClone } from "@mui/x-data-grid/utils/utils"
import { getFilteredSlabInputs, handleApplicableSlabUnsavedData } from "../components/DefineCoupon/applicableSlab/service"
import { isSlabInfoEmpty } from "../components/validationPopup/validationService"
import { filterOuletCodeFromInclusionList, getMarketTabsList, getOutletTabsList, isExclusionListEmpty, isInclusionListEmpty, isMarketFilterEmpty, getValueFromValueConcatenatedLabel } from "../components/DefineCoupon/MarketDetails/service"
import { doesProductExist, getBatchCodeFromBatchCodeSkuDescriptionString, getExtraEntityToAddToLabel, getHeadersList, getProductSearchSet, isSchemeProductBifurcationsListEmpty } from "../components/DefineCoupon/productSelection/service"
import { CouponEditType, CouponTimingSlab, manageCouponInitialStateType, rangeLevelUnitType, requeestBodyType } from "../types"
import * as Sentry from "@sentry/react";
import { EnvironmentRegistry } from "../../../services/registry/environmentRegistry"
import { isMustBuyEmpty } from "../components/DefineCoupon/mustBuy/service"
import { isUsabilityLimitNotSelected } from "../components/DefineCoupon/usabilityLimits/service"
import transformData from "../utils/Transformer"
import dayjs from "dayjs"
import { applyLocationFilter, isVersionV1, isMustBuyGroupCondition } from "../components/DefineCoupon/MarketDetails/configData"
import { convertCouponTimingToString, handleRecurrenceUnsavedData } from "../components/DefineCoupon/recurrence/RecurrenceService"



class CouponPostRequestBodyValidation extends Error {
    constructor(message: string) {
        super(message);
        this.name = "Coupon Post Request Body Validation Error";
    }
}



/**
 * This function return the options 
 * @param type id of the autocomplete or textField
 * @returns 
 */
export const getOptions = (type: string): string[] => {
    switch (type) {
        case "coupon-type-options": return [...MetaData.Coupon_Type_Options]
        case "coupon-calculation-method-BUNDLE + TOTAL ORDER VALUE": return [...MetaData.Calculation_Method_Options]
        case "coupon-calculation-method-ITEM LEVEL COUPON": return [...MetaData.Calculation_Method_Options]
        case "coupon-calculation-method-BUNDLE": return [...MetaData.Calculation_Method_Options]
        case "coupon-calculation-method-TOTAL ORDER VALUE": return [...MetaData.Calculation_Method_Options]
        case "incentive-calculation-type": return [...MetaData.Incentive_Calculation_Type]
        case "incentive-period": return [...MetaData.Incentive_Period]
        default: return [...MetaData.Calculation_Method_Options]
    }

}

/**
 * this function checks if the Usability is true in metadata 
 * @returns true if the Usability is true
 */
export const checkUsability = (): boolean => {

    const options = MetaData.Recurrence_Options;
    const usabilityOption = options.find((option: { [key: string]: boolean }) => option["Usability"] === true);
    return usabilityOption ? true : false;
};

/**
 * this function checks if the DefineNthPurchase is true in metadata 
 * @returns true if the DefineNthPurchase is true
 */
export const checkDefineNthPurchase = (): boolean => {
    const options = MetaData.Recurrence_Options;
    const defineNthPurchase = options.find((option: { [key: string]: boolean }) => option["DefineNthPurchase"] === true);
    return defineNthPurchase ? true : false;
};

/**
 * this function checks if the ActivePeriod is true in metadata 
 * @returns true if the ActivePeriod is true
 */
export const checkActivePeriod = (): boolean => {

    const options = MetaData.Recurrence_Options;
    const activePeriod = options.find((option: { [key: string]: boolean }) => option["ActivePeriod"] === true);
    return activePeriod ? true : false;
};

/**
 * this function checks if the ActiveTime is true in metadata 
 * @returns true if the ActivePeriod is true
 */
export const checkActiveTime = (): boolean => {

    const options = MetaData.Recurrence_Options;
    const activePeriod = options.find((option: { [key: string]: boolean }) => option["ActiveTime"] === true);
    return activePeriod ? true : false;
};

export const getUsabilityPeriodList = (): string[] => {
    const options = MetaData.USABILITY_PERIOD_ARRAY;
    return options || ["Daily", "Weekly", "Monthly", "Quaterly"];
};

export const isLargeExclusion = (): boolean => {
    const options = MetaData.Large_Exclusions;
    const isLargeExclusion = options==="true";
    return isLargeExclusion ? true : false;
};

export const isOnlyDateUpdate = (): boolean => {
    const options = MetaData.onlyDateUpdate;
    const isOnlyDateUpdate = options==="true";
    return isOnlyDateUpdate ? true : false;
}

export const bannerUploadActive = (): boolean => {
    const options = MetaData.banner_upload;
    const bannerUploadActive = options==="true";
    return bannerUploadActive ? true : false;
}

export const persistCouponFilters = (): boolean => {
    const options = MetaData.persistFilters;
    const persistCouponFilters = options === "true";
    return persistCouponFilters ? true : false;
}

export const getCouponFiltersFromMeta = (): string[] => {
    const options = MetaData.Coupon_Filters;
    return options || ["schemeId",  "activeStatus"];
}

export const sortCouponsByDefault = (): boolean => {
    const options = MetaData.SortByDefault;
    const sortCouponsByDefault = options === "true";
    return sortCouponsByDefault ? true : false;
}

/**
 * This function return a random stirng  `${string}-${string}-${string}-${string}-${string}`
 * @returns random number
 */
export function generateRandomId(): string {
    return crypto.randomUUID();
}



/**
 * This function generated permutation of the elements inside of nested array
 * @param arrays 2D array
 * @returns 2D Array
 */

export function generatePermutations(arrays: Array<Array<string | number>>): Array<Array<string | number>> {
    function permute(prefix: any[], remainingArrays: Array<Array<string | number>>): Array<Array<string | number>> {
        if (remainingArrays.length === 0) {
            return [prefix];
        }

        const currentArray = remainingArrays[0];

        if (currentArray.length === 0) {
            const remainingArraysTail = remainingArrays.slice(1);
            return permute(prefix, remainingArraysTail);
        }

        const permutations = currentArray.flatMap((value) => {
            const nextPrefix = [...prefix, value];
            const remainingArraysTail = remainingArrays.slice(1);
            return permute(nextPrefix, remainingArraysTail);
        });

        return permutations;
    }

    return permute([], arrays);
}


/**
 * This function get the placeholdres from the config and overrides the 
 * default placeholdres provided
 * @returns 
 */

export async function getPlaceholdres() {
    const res = await getMetaDataConfig("couponPortal", "couponPlaceHolderMeta");
    if (!res) throw new Error("no response  from meta");
    if (!res.domainValues || !Array.isArray(res.domainValues)) throw new Error("domainValues inside response is wrong")
    const data = res?.domainValues?.find((item: { name: string }) => item.name === "placeHolderMeta");
    return data.value[0];
}

export async function getEntityPriorityMeta() {
    const res = await getMetaDataConfig("couponPortal", "couponEntityPriority");
    if (!res) throw new Error("no response  from meta");
    if (!res.domainValues || !Array.isArray(res.domainValues)) throw new Error("domainValues inside response is wrong")
    const data = res?.domainValues?.find((item: { name: string }) => item.name === "couponEntityPriority");
    return data.value[0];
}


/**
 * Update the listMappings placeholders
 */
export async function updateCouponPlaceholders() {
    try {
        const placeholders = await getPlaceholdres();
        updateLabelMappings(placeholders)
    } catch (err) {
        updateMetaData({});
        console.error(err);
    }
}

export async function updateEntityPriority() {
    try {
        const placeholders = await getEntityPriorityMeta();
        updateEntityPriorities(placeholders)
    } catch (err) {
        updateMetaData({});
        console.error(err);
    }
}

/**
 * update config and metaData
 */
export async function updateConfigAndMetaData() {
    const promises = [updateMeta(), updateCouponPlaceholders(), updateEntityPriority()]
    await Promise.all(promises).then((res) => { }).catch((err) => {
        throw new Error(err);
    })
}

/**
 * get all products.
 * all fetching of data for entity would be done using the products in the response of this API
 */
export async function getAllProducts() {
    const { ALL_PRODUCTS } = store.getState()?.manageCoupons?.configData;

    if (ALL_PRODUCTS === null || ALL_PRODUCTS === undefined || ALL_PRODUCTS.length === 0) {
        const res = await ChannelkartNetworkGet('/products?size=10000&page=0&minimalResponse=true');
        const data = res?.data?.features;
        setALLPRODUCTS(data);
        return data;
    } else return ALL_PRODUCTS;

}

/**
 * Get the meta config
 * @returns 
 */

export async function getMetaConfig() {
    const res = await getMetaDataConfig("couponPortal", "couponMeta");
    if (!res) throw new Error("no response  from meta");
    if (!res.domainValues || !Array.isArray(res.domainValues)) throw new Error("domainValues inside response is wrong")
    const data = res?.domainValues?.find((item: { name: string }) => item.name === "couponMeta");
    return data.value[0];
}

/**
 * Update our metadata
 */
export async function updateMeta() {
    try {
        const config = await getMetaConfig();
        updateMetaData(config);
    } catch (err) {
        updateMetaData({});
        console.error(err);
    }
}

/**
 * This function return the priority of the entity
 * @param entityName 
 * @returns 
 */

export function getEntityPriority(entityName: string): number {
    return ENTITY_PRIORITY[entityName.toLocaleLowerCase()];
}


/**
 * sort headerlist based on priority
 * @param headerList 
 * @returns 
 */
export function sortHeaderListBasedOnPriority(headerList: string[]) {
    const temp = [...headerList];
    temp.sort((a, b) => {
        return getEntityPriority(a) - getEntityPriority(b);
    })
    return temp;
}

/**
 * remove dulplicates from an array
 * @param array
 * @returns 
 */
export function removeDuplicates(array: any[]) {
    if (array.length === 0) return [];
    // if it is string
    else if (typeof array[0] === "string")
        return Array.from(new Set(array)).filter((item) => item !== undefined);

    // if child is object having {label : ... , value: ... }
    const obj: Record<string, { label: string, value: string }> = {};

    array.forEach((item: { label: string, value: string }) => {
        if (!obj.hasOwnProperty(item.value)) {
            obj[item.value] = item;
        }
    })
    return Object.values(obj);
}


/**
 * it gets the tablist data from the currentData provided .
 * the data returned act as filter to get the specific data from all products
 * @param currentData 
 * @param tabsList 
 * @returns 
 */
export const createFilters = (currentData: Record<string, string[] | null | string>, tabsList: string[]) => {
    const filters: Record<string, string[]> = {}; // it will store tabsheader with the data selected
    for (let i = 0; i < tabsList.length; i++) {
        const currentTab = tabsList[i];
        const data = currentData[currentTab];
        if (data && Array.isArray(data) && data.length > 0) {
            if (currentTab === 'batchCode') filters[currentTab] = data.map((code: string) => getBatchCodeFromBatchCodeSkuDescriptionString(code))
            else filters[currentTab] = [...data];
        }
    }
    return filters;
}

export const validateDateLimits = (startDate: any, endDate: any) => {
    const temp: Record<string, string> = {};
    if (startDate > endDate && startDate !== null && endDate !== null) {
        temp['startDate'] = 'From Date should be less than to date';
        temp['endDate'] = 'To Date should be greater than from date';
    }
    return temp;
}




export const validateStartEndDate = () => {
    const { startDate, endDate } = store.getState()?.manageCoupons?.data?.recurrence?.dateStartEnd;
    const temp: Record<string, string> = {};
    if (startDate !== null && endDate !== null && startDate > endDate) {
        temp['startDate'] = 'Start Date should be less than end date';
        temp['endDate'] = 'End Date should be greater than start date';
        return temp;
    }
    if (startDate !== null && startDate < dayjs().startOf('day')) {
        temp['startDate'] = 'Start Date cannot be less than today';
        return temp;
    }
    if (endDate !== null && endDate < dayjs().startOf('day')) {
        temp['endDate'] = 'End Date cannot be less than today';
        return temp;
    } else {
        temp['endDate'] = "";
        temp['startDate'] = "";
    }
    return temp;
}



/*******************      Request body          ********* */

/**
 * Created request body
 * @returns 
 */
export async function createRequestBody(inclusionFile: string) {
    const { schemeType, couponTypeOption, usabilityLimits, recurrence, couponId, isSchemePlayground, couponEditType, couponTitle, banner } = store.getState()?.manageCoupons?.data;
    const schemeId: string = couponEditType === "edit" || couponEditType === "inPlaygrondMode" ? couponId : generateRandomId();
    const body: requeestBodyType = {
        schemeId: schemeId,
        schemeType,
        startDate: dayjs(recurrence.dateStartEnd.startDate).format("YYYY-MM-DDTHH:mm:ss"),
        endDate: dayjs(recurrence.dateStartEnd.endDate).format("YYYY-MM-DDTHH:mm:ss"),
        schemeDescription: "",
        status: isSchemePlayground ? "inPlayground" : "approved",
        schemeName: getCouponTitleWithPrefix(couponTitle, couponTypeOption),
        // calculationValue: null,
        // rangeLevel: null,
        criteria: couponTypeOption,
        // priority: 1,
        // programLevel: "bundle",
        // bannerUrl:banner.uploadBanner.imageUrl,
        // bannerPriority:banner.uploadBanner.bannerPriority,
        extendedAttributes: {},
        // schemeLocationBifurcationsList:await createSchemeLocationBifurcationsList(schemeId),
        schemeOutletBifurcationsList: isVersionV1() ? await createSchemeOutletBifurcationsListV1(schemeId):await createSchemeOutletBifurcationsList(schemeId, inclusionFile),
        schemeProductBifurcationsList: await createSchemeProductBifurcationsList(schemeId),
        schemeCalculation: {
            schemeType,
            schemeId: schemeId,
            criteria: couponTypeOption,
            outletLimitOnOrder: recurrence.couponLife,
            // nthOrderPeriod: "",
            // nthOrderNumber: "",
            // usabilityPeriod: "",
            // usabilityPeriodLimit: "",

            // "schemeDiscountedProductcode": "NA",
            // "schemeDiscountedProductcodeValue": null,
            // "schemeDiscountedProductcodeUOM": "NA",
            "rangeLevelUnit": getRangeLevelUnit(),
            "itemEach": 0,
            // "schemeDiscountedProductPrice": "0",
            // "mustBuyGroupId": schemeId,
            "maxDiscount": getBenefitLimit(usabilityLimits.percentageMaxAmount, schemeType),
            // "limitOnOrder": 0,
            // "customField": null,
            // "maxTerm": 0.0,
            // "usageLimit": usabilityLimits.useOnce ? 1 : 0,
            // "repeatForEvery": 0.0,
            // "minimumAmount": 0.0,
            // limitOnOrder: recurrence.couponLife,
            slabInfo: generateSlabInfo(),
            usabilityPeriodLimit: recurrence.usabilityLimit,
            usabilityPeriod: recurrence.usability,
            nthOrderPeriod: recurrence.orderResetFrequency,
            nthOrderNumber: recurrence.numberOfPurchases,
            schemeMustBuyGroupList: await generateMustBuy(schemeId),
        },
        ...(applyLocationFilter() ? { schemeLocationBifurcationsList:(isVersionV1()?await createSchemeLocationBifurcationsListV1(schemeId): await createSchemeLocationBifurcationsList(schemeId)) } : {schemeLocationBifurcationsList:[]}),
        activeDates: recurrence.isActivePeriodSaved ? recurrence.activePeriodCustomDates : [],
        activeDays: recurrence.isActivePeriodSaved ? recurrence.activePeriodDays : [],
        activeWeeks: recurrence.isActivePeriodSaved ? recurrence.activePeriodWeeks : [],
        activeMonths: recurrence.isActivePeriodSaved ? recurrence.activePeriodMonths : [],
        activeTime: createActiveTimeList(),
    }
    return formSchemeCustomProperties(body);
}


function createActiveTimeList():Array<string>{
    const { couponTimings} = store.getState()?.manageCoupons?.data?.recurrence;
    const ans:Array<string> = [];
    
    couponTimings.forEach((timing:CouponTimingSlab)=>{
        const {isSaved ,st , et} = timing;
        if(isSaved && st && et){
            ans.push(convertCouponTimingToString(dayjs(st))+'&'+convertCouponTimingToString(dayjs(et)));
        }
    })

    return ans;
}

function getBenefitLimit(percentageMaxAmount: any, schemeType: any) {
    if (schemeType.toLowerCase() === "percentage") {
        return percentageMaxAmount === "" ? null : Number(percentageMaxAmount);
    }
    return 0;
}


/**
 *  return range level unit based on applicable slab unit
 * @returns 
 */

function getRangeLevelUnit(): rangeLevelUnitType {
    const { slabUnit, quantityUnit } = store.getState()?.manageCoupons?.data?.slabInfo;
    return slabUnit === labelMappings["applicable-slab-qty"] ? quantityUnit.toLowerCase() === "case" ? "cs" : "nq" : "amount";
}

/**
 * Creates post body for products added in product selection
 * @param schemeId 
 * @returns 
 */

async function createSchemeProductBifurcationsList(schemeId: string) {
    const { schemeProductBifurcationsList, sectionEnabled } = store.getState()?.manageCoupons?.data;
    const headerList = await getHeadersList();

    // sending all against each property
    if (!sectionEnabled["schemeProductBifurcationsList"]) {
        const res: any = {};
        headerList.forEach((header: string) => {
            res[header] = 'all'
        })
        res["schemeId"] = schemeId;
        const newRes = addExtraFields(res, ID_MAP_EXTRA_FIELDS["product"], 'all');
        return [newRes];
    }

    const ans:any = [];
    schemeProductBifurcationsList.forEach((grp:any)=>{
        const data:any = [];
        const lookUpHeaders:string[] = [];
        const nonLookUpHeaders:string[] = [];
        headerList.forEach((header:string)=>{
            if(grp[header] && grp[header].length > 0){
                if(header === 'batchCode') data.push(grp[header].map((code:string)=>getBatchCodeFromBatchCodeSkuDescriptionString(code)))
                else data.push(grp[header]);

                lookUpHeaders.push(header);
            }else{
                nonLookUpHeaders.push(header);
            }       
        })

        const perms = generatePermutations(data);
        const productSearchSet = getProductSearchSet(lookUpHeaders);
        perms.forEach((perm)=>{
            const res:any = {};

            if(isValidPermuation(perm,lookUpHeaders)){
                perm.forEach((val,idx)=>{
                    const entityName = lookUpHeaders[idx];
                    res[entityName] = val;
                    res["schemeId"] = schemeId

                    nonLookUpHeaders.forEach((nonLookUpHeader:string)=>{
                        res[nonLookUpHeader] = 'all';
                    })
                })
                const newRes = addExtraFields(res, ID_MAP_EXTRA_FIELDS["product"], 'all');
                ans.push(newRes);
            }

        })
    })

    if (ans.length === 0) {
        const res: any = {};
        headerList.forEach((header: string) => {
            res[header] = 'all'
        })
        res["schemeId"] = schemeId;
        const newRes = addExtraFields(res, ID_MAP_EXTRA_FIELDS["product"], 'all');
        ans.push(newRes);
    }

    ans.forEach((obj: any) => {
        obj["schemeId"] = schemeId;
    });
    return ans;
}


function isValidPermuation(perm: (string | number)[], headerList: string[]) {
    const features: Record<string, any> = {};
    perm.forEach((val, index) => {
        if (val.toString().toLowerCase() !== ALL.toLowerCase())
            features[headerList[index]] = val;
    })
    return doesProductExist(features);
}

/**
 * Creates post body for outlet bifurcation data
 * @param schemeId 
 * @returns 
 */

async function createSchemeOutletBifurcationsList(schemeId: string, inclusionFile: string) {
    const { schemeOutletBifurcationsList, couponTypeOption, skipMarketSelection } = store.getState()?.manageCoupons?.data;

    //if inclusionFile has url for s3 file, data will be processed through file stream
    if(isLargeExclusion() && inclusionFile !== "") {
        return [];
    }

    if (skipMarketSelection === true) {
        return [];
    }


    let ans: Record<string, string>[] = [];
    const headerList = await getOutletTabsList();

    const inclusionData = await getInclusionOutletCodes(schemeId);
    ans = [...ans, ...inclusionData];
    let allEmpty = true;
    schemeOutletBifurcationsList.forEach((item: any) => {
        headerList.forEach((header: string) => {
            if (item[header].length !== 0) {
                allEmpty = false;
            }
        });
    });
    if (ans.length === 0 && allEmpty) {
        const res: Record<string, string> = {};
        headerList.forEach((header: string) => {
            const dbColName = COLUMN_NAME_MAP_DB_COLUMN_NAME[header] ?? header
            res[dbColName] = 'all'
        })
        res["schemeId"] = schemeId;
        let newRes = addExtraFields(res, ID_MAP_EXTRA_FIELDS["outlet"], 'all');
        newRes["extendedAttributes"] = { "id": schemeOutletBifurcationsList[0].id };
        newRes = addMarketDates(newRes);
        ans.push(newRes);
    }



    return ans;
}

async function createSchemeOutletBifurcationsListV1(schemeId: string) {
    const { schemeOutletBifurcationsList, couponTypeOption, skipMarketSelection } = store.getState()?.manageCoupons?.data;

    if (skipMarketSelection === true) {
        return [];
    }


    let ans: Record<string, string>[] = [];
    const headerList = await getOutletTabsList();

    schemeOutletBifurcationsList?.forEach((outletFilter: any) => {
        const data: Array<Array<string>> = [];
        headerList.forEach((item: string) => {
            if (outletFilter[item]) {
                if (outletFilter[item].length === 0) data.push(['all']);
                else data.push(outletFilter[item].map((val: string) => getValueFromValueConcatenatedLabel(val, item)));
            }
        })
        const perms = generatePermutations(data);
        perms.forEach((perm) => {
            const res: Record<string, string> = {};
            perm.forEach((val, idx) => {
                const entityName = headerList[idx];
                const dbColName = COLUMN_NAME_MAP_DB_COLUMN_NAME[entityName] ?? entityName
                res[dbColName] = val as string;
                res["schemeId"] = schemeId
            })
            const newRes = addExtraFields(res, ID_MAP_EXTRA_FIELDS["outlet"], 'all');
            addMarketDates(newRes);
            newRes["extendedAttributes"] = { "id": outletFilter.id };
            ans.push(newRes);
        })
    })

    const inclusionData = await getInclusionOutletCodes(schemeId);
    ans = [...ans, ...inclusionData];

    if (ans.length === 0) {
        const res: Record<string, string> = {};
        headerList.forEach((header: string) => {
            const dbColName = COLUMN_NAME_MAP_DB_COLUMN_NAME[header] ?? header
            res[dbColName] = 'all'
        })
        res["schemeId"] = schemeId;
        const newRes = addExtraFields(res, ID_MAP_EXTRA_FIELDS["outlet"], 'all');
        ans.push(newRes);
    }



    return ans;
}





/**
 * this function add market start date and end date if exist
 * @param newRes 
 */
function addMarketDates(newRes: any){
    const newObj = deepClone(newRes);
    const {nDaysFromActivation,dateStartEnd} = store.getState()?.manageCoupons?.data.recurrence;
    if(!nDaysFromActivation){
        return newObj;
    }
    const startDate = dayjs(dateStartEnd.startDate);
    const now = dayjs();
    const DateToConsider = now.isAfter(startDate)?now:startDate;
    newObj["marketStartDate"] = DateToConsider.format("YYYY-MM-DDTHH:mm:ss.SSSZ");
    const marketEndDate = dayjs(DateToConsider).add(nDaysFromActivation, 'day').format("YYYY-MM-DDTHH:mm:ss.SSSZ");
    newObj["marketEndDate"] = marketEndDate;
    return newObj;
}

/**
 * Creates post body for inclusion of ouletcode data
 * @param schemeId 
 * @returns 
 */

async function getInclusionOutletCodes(schemeId: string) {
    const { list: inclusionList } = store.getState()?.manageCoupons?.data?.inclusionData;
    const headerList = await getOutletTabsList();
    const ans: Record<string, string>[] = [];
    const finalOutletCodes = await removeRedundantOutletCode(inclusionList);

    finalOutletCodes.forEach((outletCode: string) => {
        const res: Record<string, string> = {};
        headerList.forEach((header: string) => {
            const dbColName = COLUMN_NAME_MAP_DB_COLUMN_NAME[header] ?? header
            if (dbColName.toLowerCase() === 'outletcode') {
                res["outletCode"] = outletCode.toString();
            } else res[dbColName] = 'all'
        })
        res["schemeId"] = schemeId;
        const newRes = addExtraFields(res, ID_MAP_EXTRA_FIELDS["outlet"], 'all');
        ans.push(newRes);
    })

    return ans;
}

/**
 * This function removes the outletcode which are duplicates in inclusion list and selected mareket filters outlet codes.
 * It makes an api call to get valid outlets.
 * @param inclusionList list of outletcodes in the inclusion list
 * @returns 
 */
async function removeRedundantOutletCode(inclusionList: Array<string>): Promise<string[]> {

    let requestBody: any = await prepareBodyForSelectedOutletProps();

    const { nonOverlappingData } = filterOuletCodeFromInclusionList(inclusionList);


    if (Object.keys(requestBody).length === 0) {
        return nonOverlappingData;
    }
    requestBody['outletcode'] = nonOverlappingData;


    try {
        return await getValidOutlets(requestBody);

    } catch (err) {
        console.error(err);
        return []
    }
}
/**
 * Function to get valid outlets
 * @param requestBody 
 * @returns list of valid outletCodes
 */

async function getValidOutlets(requestBody: any) {
    let url = '/v1/getValidOutlets';

    const response = await ChannelkartNetworkPost(url, requestBody);
    if (response.status !== 200 && response.status !== 201) {
        throw new Error("Some Error Occured while saving Coupon");
    } else {
        return response.data.outletCode;
    }


}

/**
 * This function created the request body with approprite filters for getValidOutlet api
 * of inclusion list
 * While creating filters we will ignore the outletcode selected in market details selector
 * and consider filers from lower priority to higher (higer numeric value to lowe) i.e. channel > distributionChannel(ASM) > DistributorDetails(supplier) 
 * and ignore those filters whose value is null or empty array
 * @returns 
 */
async function prepareBodyForSelectedOutletProps() {
    const { schemeOutletBifurcationsList } = store.getState()?.manageCoupons?.data;
    const headerList = await getOutletTabsList();
    let body: Record<string, string[]> = {};
    schemeOutletBifurcationsList.forEach((outletSelectedFilters: any) => {

        // lenght - 2 because we have to ignore outletCode as well
        for (let i = headerList.length - 2; i >= 0; i--) {
            const outletColumn = headerList[i];
            if (outletSelectedFilters[outletColumn] && outletSelectedFilters[outletColumn].length > 0 && outletSelectedFilters[outletColumn][0].toLowerCase() !== "all") {
                const colNameInDb = COLUMN_NAME_MAP_DB_COLUMN_NAME_FOR_VALID_OUTLET[outletColumn] ?? outletColumn;
                body = addValueInRequestBody(body, colNameInDb, outletSelectedFilters[outletColumn][0]);
                break;
            }
        }
    });
    return body;
}

/**
 * added values in request body of getValidOutlet for outlet inclusion
 * @param requestBody 
 * @param outletColumn 
 * @param outletValue 
 * @returns 
 */
function addValueInRequestBody(requestBody: Record<string, string[]>, outletColumn: string, outletValue: string) {
    const copyRequestBody = { ...requestBody };
    if (!copyRequestBody[outletColumn]) {
        copyRequestBody[outletColumn] = [];
    }
    copyRequestBody[outletColumn].push(outletValue);
    return copyRequestBody;
}

/**
 * Creates post body for applicable slab data
 * @returns 
 */
function generateSlabInfo() {
    const { sectionEnabled, slabInfo } = store.getState()?.manageCoupons?.data;
    const { data } = slabInfo
    const inputs = getFilteredSlabInputs();

    if (!sectionEnabled["applicableSlab"] || isSlabInfoEmpty()) {
        return [];
    }


    const ans: Record<string, string>[] = [];

    data.forEach((item: any) => {
        if (item.isEdit === false) {
            const temp: Record<string, string> = {};
            inputs.forEach((ip: { id: string }) => {
                const id = ip.id;
                temp[ID_MAP_API_REQUEST_FIELD[id]] = item[id];
            })
            ans.push(temp);
        }
    })


    if (ans.length === 0) {
        const res: Record<string, string> = {};
        inputs.forEach((ip: { id: string }) => {
            const id = ip.id;
            res[ID_MAP_API_REQUEST_FIELD[id]] = 'all'
        })
        ans.push(res);
    }

    return ans;

}

/**
 * Creates post body for must buy data
 * @param schemeId 
 * @returns 
 */

async function generateMustBuy(schemeId: string) {

    const { sectionEnabled } = store.getState()?.manageCoupons?.data;
    const { data: mustBuy, quantityUnit } = store.getState()?.manageCoupons?.data?.mustBuy;

    if (!sectionEnabled["mustBuy"] || !mustBuy || mustBuy.length === 0) {
        return []
    }

    const ans: Record<string, string>[] = [];
    const headerList: string[] = [... await getHeadersList(), "min_qty", "must_buy_group_condition"];
    mustBuy.forEach((grp: Record<string, any>) => {
        const data: Array<Array<string>> = []
        // this will help us to get headerName after permutations are created
        const lookUpHeaders: string[] = [];

        headerList.forEach((header: string) => {
            if (grp && grp[header] && grp[header].length > 0) {
                if (header === 'batchCode') data.push(grp[header].map((code: string) => getBatchCodeFromBatchCodeSkuDescriptionString(code)))
                else if (typeof grp[header] === "string") data.push([grp[header]]);
                else data.push(grp[header]);

                lookUpHeaders.push(header);
            }
        })

        const perms = generatePermutations(data);
        // const productSearchSet = getProductSearchSet(lookUpHeaders);
        perms.forEach((perm)=>{
            const res:Record<string,string> = {};
            if(isValidPermuation(perm,lookUpHeaders)){
                perm.forEach((val,idx)=>{
                    const entityName = lookUpHeaders[idx];
                    const entityNameInDB = ID_MAP_API_REQUEST_FIELD[entityName] ?? entityName
                    res[entityNameInDB] = val as string;
                    res["mustByGroupId"] = schemeId;
                    res["schemeId"] = schemeId;
                    res["unit"] = quantityUnit.toLowerCase() === labelMappings["quantity-unit-value-case"].toLowerCase() ? "cs" : "nq";
                })
                const newRes = addExtraFields(res, ID_MAP_EXTRA_FIELDS["product"], 'all');
                ans.push(newRes);
            }
        })
    })
    return ans;

}

/**
 * Creates post body for location bifurcation data
 * @param schemeId 
 * @returns 
 */
async function createSchemeLocationBifurcationsList(schemeId: string) {
    const { schemeLocationBifurcationsList,schemeOutletBifurcationsList, couponTypeOption, skipMarketSelection } = store.getState()?.manageCoupons?.data;

    if (skipMarketSelection === true) {
        return [];
    }

    const headerList = await getMarketTabsList();

    const ans: Record<string, string>[] = [];
    let allEmpty = true;
    schemeLocationBifurcationsList.forEach((item: any) => {
        headerList.forEach((header: string) => {
            if (item[header].length !== 0) {
                allEmpty = false;
            }
        });
    });

    if (ans.length === 0 && allEmpty) {
        const res: Record<string, string> = {};
        headerList.forEach((header: string) => {
            const dbColName = COLUMN_NAME_MAP_DB_COLUMN_NAME[header] ?? header
            res[dbColName] = 'all'
        })
        res["schemeId"] = schemeId;
        const newRes = addExtraFields(res, ID_MAP_EXTRA_FIELDS["location"], 'all');
        if(schemeOutletBifurcationsList[0]!==undefined){
            newRes["extendedAttributes"] = { "id": schemeOutletBifurcationsList[0].id };
        }
        
        ans.push(newRes);
    }

    return ans;
}
async function createRecurrenceBody() {
    let recurrenceDetails = store.getState()?.manageCoupons?.data?.recurrence;
    // recurrenceMapper
    return recurrenceDetails;
}

async function createSchemeLocationBifurcationsListV1(schemeId: string) {
    const { schemeLocationBifurcationsList, couponTypeOption, skipMarketSelection } = store.getState()?.manageCoupons?.data;

    if (skipMarketSelection === true) {
        return [];
    }

    const headerList = await getMarketTabsList();

    const ans: Record<string, string>[] = [];

    schemeLocationBifurcationsList?.forEach((item: any) => {
        const data: Array<Array<string>> = [];
        headerList.forEach((header: string) => {
            if (item[header]) {
                if (item[header].length === 0) data.push(['all']);
                else data.push(item[header]);
            }
        })
        const perms = generatePermutations(data);
        perms.forEach((perm) => {
            const res: Record<string, string> = {};
            perm.forEach((val, idx) => {
                const entityName = headerList[idx];
                const dbColName = COLUMN_NAME_MAP_DB_COLUMN_NAME[entityName] ?? entityName
                res[dbColName] = val as string;
                res["schemeId"] = schemeId
            })
            const newRes = addExtraFields(res, ID_MAP_EXTRA_FIELDS["location"], 'all');
            newRes["extendedAttributes"] = { "id": item.id };
            ans.push(newRes);
        })
    })

    if (ans.length === 0) {
        const res: Record<string, string> = {};
        headerList.forEach((header: string) => {
            const dbColName = COLUMN_NAME_MAP_DB_COLUMN_NAME[header] ?? header
            res[dbColName] = 'all'
        })
        res["schemeId"] = schemeId;
        const newRes = addExtraFields(res, ID_MAP_EXTRA_FIELDS["location"], 'all');
        ans.push(newRes);
    }
    return ans;
}

/**
 * Creates the post request body for saving scheme
 * @param body 
 * @returns 
 */
function formSchemeCustomProperties(body: requeestBodyType) {

    const { list: exclusionList } = store.getState()?.manageCoupons?.data?.exclusionData;
    const { banner } = store.getState()?.manageCoupons?.data;
    // const {percentageMaxAmount}= store.getState()?.manageCoupons?.data?.usabilityLimits;

    const schemeBodyCopy: requeestBodyType = deepClone(body);
    schemeBodyCopy.programLevel = getSchemeProgramLevel(body.schemeCalculation.criteria, isMustBuyScheme(body.schemeCalculation));
    schemeBodyCopy.criteria = getSchemeCriteria(body.schemeCalculation.criteria);
    schemeBodyCopy.schemeCalculation.criteria = schemeBodyCopy.criteria;
    schemeBodyCopy.schemeCalculation.forEach = getSchemeForEach(body.criteria);
    schemeBodyCopy.priority = getSchemePriority(schemeBodyCopy.criteria, body.schemeCalculation.criteria);
    schemeBodyCopy.schemeCalculation.usageLimit = schemeBodyCopy.criteria.toLowerCase() === "totalorder_welcome" ? 1 : body.schemeCalculation.usageLimit;
    schemeBodyCopy.extendedAttributes = getExtendedAttributes(schemeBodyCopy);

    if (body.schemeCalculation.schemeMustBuyGroupList.length > 0) {
        schemeBodyCopy.schemeCalculation.mustBuyGroupId = body.schemeId;
    }

    if (!isLargeExclusion() && exclusionList.length > 0) {
        schemeBodyCopy.schemeCalculation.outletExclusionKey = 'outletCode';
        schemeBodyCopy.schemeCalculation.outletExclusionValues = [...exclusionList];
    }
    if (body.schemeCalculation.usabilityPeriod !== undefined && body.schemeCalculation.usabilityPeriod === "") {
        delete schemeBodyCopy.schemeCalculation.usabilityPeriod;
    }
    if (body.schemeCalculation.nthOrderPeriod !== undefined && body.schemeCalculation.nthOrderPeriod === null || body.schemeCalculation.nthOrderPeriod === "") {
        delete schemeBodyCopy.schemeCalculation.nthOrderPeriod;
    }
    if (body.schemeCalculation.nthOrderNumber !== undefined && body.schemeCalculation.nthOrderNumber === null || body.schemeCalculation.nthOrderPeriod === "") {
        delete schemeBodyCopy.schemeCalculation.nthOrderNumber;
    }
    if (body.schemeCalculation.usabilityPeriodLimit !== undefined && body.schemeCalculation.usabilityPeriodLimit === "") {
        delete schemeBodyCopy.schemeCalculation.usabilityPeriodLimit;
    }

    // if(body.schemeType === "percentage"){
    //     schemeBodyCopy.schemeCalculation.maxDiscount = percentageMaxAmount === "" ? null : Number(percentageMaxAmount);
    // }

    if (banner.uploadBanner.imageUrl !== "") {
        schemeBodyCopy.bannerUrl = banner.uploadBanner.imageUrl;
    }
    if (banner.uploadBanner.bannerPriority !== "") {
        schemeBodyCopy.bannerPriority = banner.uploadBanner.bannerPriority;
    }
    return schemeBodyCopy;
}

/**
 * This function return the scheme criteria (returned criteria is different than what we save in redux)
 * @param criteria 
 * @returns 
 */
function getSchemeCriteria(criteria: string): string {
    if (COUPON_TYPE_OPTIONS_VALUE.ITEM_LEVEL_COUPON === criteria) {
        return "itemwise";
    } else if (criteria === COUPON_TYPE_OPTIONS_VALUE.TOTAL_ORDER_VALUE) {
        return "totalOrder";
    } else if (criteria === COUPON_TYPE_OPTIONS_VALUE.TOTAL_ORDER_WELCOME) {
        return "totalOrder_welcome"
    } else {
        return "itemwise_group";
    }
}

/**
 * return the programLevel based on scheme criterai
 */
function getSchemeProgramLevel(criteria: String, isMustBuyScheme: boolean): string {
    if (COUPON_TYPE_OPTIONS_VALUE.BUNDLE_PLUS_TOTAL_ORDER_VALUE === criteria || COUPON_TYPE_OPTIONS_VALUE.ITEM_LEVEL_COUPON === criteria || criteria === COUPON_TYPE_OPTIONS_VALUE.BUNDLE) {
        return "ILC";
    }
    else {
        return "COUPON";
    }
}


/**
 * This function return the forEach value of the scheme
 * @param criteria 
 * @returns 
 */
function getSchemeForEach(criteria: string): number {
    if (criteria.toLowerCase() === "" || criteria.toLowerCase() === "scheme") {
        return 1;
    }
    return 0;
}

/**
 * This function return scheme priority
 * @param criteria 
 * @param uiCriteria 
 * @returns 
 */
function getSchemePriority(criteria: string, uiCriteria: String): number {
    const specialUICriteria = [
        "bundle_+_total_order_value",
        "item_level_coupon",
        "bundle",
    ];
    const isOverAndAbove = store.getState()?.manageCoupons?.data?.isOverAndAbove;
    if (isOverAndAbove) {
        return -1;
    }
    else if (criteria.toLowerCase() === "totalorder_welcome" || specialUICriteria.includes(uiCriteria.toLowerCase())) {
        return 1;
    }
    else {
        return 2;
    }
}


/*************************************************************** */


/**
 * set all the values of the object as empty array except the id prop
 * @param obj 
 * @returns 
 */
export function setAllPropAsEmptyArray(obj: Record<string, string[] | string | null>) {
    const ans: Record<string, string[]> = {};
    Object.keys(obj).forEach((key: string) => {
        if (key !== "id")
            ans[key] = [];
    })
    return ans;
}


/**
 * Post the data
 */
export const postScheme = async (inclusionFile: string, exclusionFile: string) => {
    //create request body
    const requestBody = await createRequestBody(inclusionFile);
    const validationResponse = schemePostValidator(requestBody);

    if (validationResponse.length > 0) {
        const validationErr = validationResponse.map((item) => JSON.stringify(item)).toString();
        Sentry.captureException(new CouponPostRequestBodyValidation(validationErr), {
            extra: {
                requestBody: JSON.stringify(requestBody)
            },
            user: {
                lob: EnvironmentRegistry.getCurrentLob()
            },
            level: "error"
        });
        throw new Error(labelMappings["REQUEST_BODY_VALIDATION_FAILED"]);
    }
    else {
        try {
            const url = isVersionV1() ? "/v1/schemes/addScheme" : "/v1/schemes/v2/addScheme";
            const response = await ChannelkartNetworkPost(url, requestBody);
            if (response.status !== 200 && response.status !== 201) {
                if (response.status !== 200 && response.status !== 201) {
                    const err = new Error("Some error occurred while saving data");
                    (err as any).response = response; 
                    throw err;
                }                
            } else {
                const { isSchemePlayground } = store.getState()?.manageCoupons?.data;
                if (isSchemePlayground) {
                    cacheSchemePlayGroundReduxState(requestBody.schemeId, store.getState()?.manageCoupons)
                }
            }
            return requestBody;
        } catch (error: any) {
            Sentry.captureException(new CouponPostRequestBodyValidation("Coupon Save error"), {
                extra: {
                    requestBody: JSON.stringify(requestBody)
                },
                user: {
                    lob: EnvironmentRegistry.getCurrentLob()
                },
                level: "error"
            });
            let errorMessage = "Some error occurred while saving data"; 

            if (error.response?.data) {
                const validationErrors = error.response.data["Validation Failures"];
                if (Array.isArray(validationErrors) && validationErrors.length > 0) {
                    errorMessage = validationErrors.join("\n");
                } else if (typeof validationErrors === "string") {
                    errorMessage = validationErrors;
                }
            }

            throw new Error(errorMessage);
        }
    }
}

export const editCouponDates = async () => {
    const { recurrence, couponId } = store.getState()?.manageCoupons?.data;
    const endDate = dayjs(recurrence.dateStartEnd.endDate).format("YYYY-MM-DDTHH:mm:ss");
    const startDate = dayjs(recurrence.dateStartEnd.startDate).format("YYYY-MM-DDTHH:mm:ss");
    let url = "/v1/schemes/update?schemeId=" + couponId + "&activeStatus=active&endDate=" + endDate + "&startDate=" + startDate;
    const response = await ChannelkartNetworkPatch(url);
    if (response.status !== 200 && response.status !== 201) {
        throw new Error("Some Error Occured while updating Coupon")
    }
}

export const postOutletLists = async (schemeId: string, inclusionFileUrl: string, exclusionFileUrl: string) => {
    const outletRequestBody = await createOutletRequestBody(schemeId, inclusionFileUrl, exclusionFileUrl);
    try {
        const response = await ChannelkartNetworkPost("/v1/schemes/processS3File", outletRequestBody);
        return response;
    } catch (error) {
            const currentDate = new Date();
            currentDate.setMonth(currentDate.getMonth() - 4);
            const expiredDate = dayjs(currentDate).format("YYYY-MM-DDTHH:mm:ss");
            let url = "/v1/schemes/update?schemeId="+schemeId+"&activeStatus=inactive&endDate="+expiredDate;
            const response = await ChannelkartNetworkPatch(url);
            if(response.status !== 200 && response.status !== 201) {
                throw new Error("Some Error Occured while saving Coupon")
            }
        throw new Error("Some Error Occured while saving Coupon");
    }
}

export async function createOutletRequestBody(schemeId: string, inclusionFileUrl: string, exclusionFileUrl: string) {
    const body: requeestBodyType = {
        schemeId: schemeId,
        type: "xlsx",
        inclusionFilePath: inclusionFileUrl,
        exclusionFilePath: exclusionFileUrl
    }
    return body;
}



/**
 * return boolean whether scheme is must buy or not
 * @param schemeCalculation 
 * @returns 
 */
function isMustBuyScheme(schemeCalculation: Record<string, any>): boolean {
    return schemeCalculation.schemeMustBuyGroupList && schemeCalculation.schemeMustBuyGroupList.length > 0;
}


/**
 * Creates the options with value and label of the option
 * @param entityName 
 * @param list
 * @returns 
 */
export const createOptionsWithLabel = (entityName: string, list: any[]): { value: string, label: string }[] => {
    // in some cases we need to show the label with extra text (eg. we show skuCode with product description)
    // extraEntityToAddToLabel : the extra text we want to add to label
    const extraEntityToAddToLabel: string | null = getExtraEntityToAddToLabel(entityName);
    return list.map((item) => {
        const label = extraEntityToAddToLabel === null ? item[entityName] : item[entityName] + ' ( ' + item[extraEntityToAddToLabel] + ' )'
        return {
            value: label,
            label
        }
    });
}


/**
 * It changes all the values of an object which are all to null
 * This helps in converting our row data (which shows all) to value we store in state
 * @param data 
 * @returns 
 */

export function changeALLTONULL(data: Record<string, any>) {
    const newData: Record<string, any> = {};

    for (let prop in data) {
        if (data[prop] === ALL) {
            newData[prop] = null;
        } else {
            newData[prop] = data[prop];
        }
    }

    return newData;
}

/**
 * This function will add extra field in request body , which needs to be set up before sending 
 * data to backend
 * @param values current values
 * @param mustHaveKeys these keys must be present in the value
 * @param valueToAdd value which is being set on the mustHaveKeys.
 * @returns 
 */

function addExtraFields(values: Record<string, string>, mustHaveKeys: string[], valueToAdd: string) {
    const newObj = deepClone(values);
    mustHaveKeys.forEach((key: string) => {
        if (!values.hasOwnProperty(key)) {
            newObj[key] = valueToAdd;
        }
    })
    return newObj;
}


/**
 * This function will validate the request body and will not post the coupon/schemee
 * if any discrepancy is found
 * @param requestBody 
 * @returns 
 */
const schemePostValidator = (requestBody: Record<string, any>): Array<{ message: string }> => {
    if (requestBody === null) return [{
        message: `Request Body is null`
    }]

    let response: { message: string }[] = [];

    POST_NULL_CHECKS.forEach((item: { field: string, shouldNotBe?: any[] }) => {

        const invalidVals: any[] = item.shouldNotBe ?? [null, undefined];

        let finalVal = requestBody;
        item.field.split(".").forEach((prop) => {
            if (finalVal)
                finalVal = finalVal[prop];
        })

        if (invalidVals.includes(finalVal)) {
            response.push({
                message: `requestBody.${item.field} is ${finalVal}`
            })
        }
    })

    if (requestBody.schemeCalculation.schemeMustBuyGroupList && requestBody.schemeCalculation.schemeMustBuyGroupList.length > 0 && !requestBody.schemeCalculation.mustBuyGroupId) {
        response.push({
            message: `requestBody.schemeCalculation.mustBuyGroupId is ${requestBody.schemeCalculation.mustBuyGroupId}`
        })
    }


    response = [
        ...response,
        ...postValidatorSlabInfo(requestBody),
        ...(applyLocationFilter() ? postValidatorSchemeLocationBifurcation(requestBody) : []),
        ...postValidatorSchemeOutletBifurcation(requestBody),
        ...postValidatorSchemeProductBifurcation(requestBody),
    ]

    return response;
}

/**
 * This function will validate the locationBifurcation data in request body of coupon/scheme
 * post request
 * @param requestBody 
 * @returns 
 */
const postValidatorSchemeLocationBifurcation = (requestBody: Record<string, any>) => {
    const response: { message: string }[] = [];

    if (requestBody.schemeLocationBifurcationsList === null) {
        response.push({ message: `requestBody.schemeLocationBifurcationsList is null` });
    } else {
        requestBody.schemeLocationBifurcationsList.forEach((item: Record<string, string>, idx: number) => {
            POST_SchemeLocationBifurcationsList_CHECKS.forEach((check: { field: string, shouldNotBe?: any[] }) => {
                const invalidVals: any[] = check.shouldNotBe ?? [null, undefined];
                if (invalidVals.includes(item[check.field])) {
                    response.push({
                        message: `requestBody.schemeLocationBifurcationsList[${idx}].${check.field} is ${item[check.field]}`
                    })
                }
            })
        })
    }

    return response;
}


/**
 * This function will validate the outletBifurcation data in request body of coupon/scheme
 * post request
 * @param requestBody 
 * @returns 
 */
const postValidatorSchemeOutletBifurcation = (requestBody: Record<string, any>) => {
    const response: { message: string }[] = [];

    if (requestBody.schemeOutletBifurcationsList === null) {
        response.push({ message: `requestBody.schemeOutletBifurcationsList is null` });
    } else {
        requestBody.schemeOutletBifurcationsList.forEach((item: Record<string, string>, idx: number) => {
            POST_SchemeOutletBifurcationsList_CHECKS.forEach((check: { field: string, shouldNotBe?: any[] }) => {
                const invalidVals: any[] = check.shouldNotBe ?? [null, undefined];
                if (invalidVals.includes(item[check.field])) {
                    response.push({
                        message: `requestBody.schemeOutletBifurcationsList[${idx}].${check.field} is ${item[check.field]}`
                    })
                }
            })
        })
    }
    return response;
}

/**
 * This function will validate the ProductBifurcation data in request body of coupon/scheme
 * post request
 * @param requestBody 
 * @returns 
 */
const postValidatorSchemeProductBifurcation = (requestBody: Record<string, any>) => {
    const response: { message: string }[] = [];


    if (requestBody.schemeProductBifurcationsList === null) {
        response.push({ message: `requestBody.schemeProductBifurcationsList is null` });
    } else {
        requestBody.schemeProductBifurcationsList.forEach((item: Record<string, string>, idx: number) => {
            POST_SchemeProductBifurcationsList_CHECKS.forEach((check: { field: string, shouldNotBe?: any[] }) => {
                const invalidVals: any[] = check.shouldNotBe ?? [null, undefined];
                if (invalidVals.includes(item[check.field])) {
                    response.push({
                        message: `requestBody.schemeProductBifurcationsList[${idx}].${check.field} is ${item[check.field]}`
                    })
                }
            })
        })
    }
    return response;
}



export const postValidatorSlabInfo = (requestBody: Record<string, any>) => {
    const response: { message: string }[] = [];
    const { schemeCalculation } = requestBody;

    if (schemeCalculation.slabInfo === null) {
        response.push({ message: `schemeCalculation.slabInfo is null` });
    }
    else if (schemeCalculation.slabInfo.length === 0) {
        response.push({ message: `schemeCalculation.slabInfo is empty array` })
    }
    else {
        schemeCalculation.slabInfo.forEach((slab: Record<string, string>, idx: number) => {
            POST_SLAB_INFO_CHECKS.forEach((check: { field: string, shouldNotBe?: any[] }) => {
                const invalidVals: any[] = check.shouldNotBe ?? [null, undefined];
                if (invalidVals.includes(slab[check.field])) {
                    response.push({
                        message: `schemeCalculation.slabInfo[${idx}].${check.field} is ${slab[check.field]}`
                    })
                }
            })
        })
    }
    return response;
}


export const isDataPresent = () => {
    return !isSchemeTypeEmpty() ||
        !isSchemeProductBifurcationsListEmpty() ||
        !isMustBuyEmpty() ||
        !isMarketFilterEmpty() ||
        !isInclusionListEmpty() ||
        !isExclusionListEmpty() ||
        !isUsabilityLimitNotSelected();

}

const isSchemeTypeEmpty = () => {
    const { schemeType } = store.getState().manageCoupons.data;
    return schemeType === null || schemeType === undefined || schemeType === "";
}


export async function getAndPutSchemeData(schemeId: String, editType: CouponEditType) {
    const schemeData: Record<string, any> = await getSchemeDetails(schemeId);
    const updatedState: manageCouponInitialStateType = await transformData(schemeData, editType);
    cloneWholeScheme(updatedState);
}

async function getSchemeDetails(schemeId: String) {
    const res = await ChannelkartNetworkGet('/v1/schemes?schemeId=' + schemeId);
    return res?.data;
}

function getCouponTitleWithPrefix(couponTitle: string, couponTypeOption: any): string {
    //first check to check whether the couponType option short form available or not
    //second check to make sure while scheme is posted from edit, clone or inplayground mode again the couponTitle is not added with prefix
    if (couponTitlePrefix[couponTypeOption] && couponTitle && couponTitle.length > 0 && couponTitle.match(couponTitlePrefix[couponTypeOption]) == null) {
        let prefix = couponTitlePrefix[couponTypeOption];
        if (prefix) {
            prefix += "_";
        }
        return prefix + couponTitle;
    }
    return couponTitle;
}

export function checkUnsavedData(): string {

    const res = handleApplicableSlabUnsavedData();
    const res2 = handleRecurrenceUnsavedData();

    if (res !== null && res !== "") {
        return res;
    }
    if (res2 !== null && res2 !== "") {
        return res2;
    }


    else return "";
}

/**
 * Validate Usability limits data
 * @returns 
 */

export const validateUsabilityLimits = () => {
    const { startDate, endDate } = store.getState()?.manageCoupons?.data?.usabilityLimits;
    const temp: Record<string, string> = {};
    if (startDate > endDate && startDate !== null && endDate !== null) {
        temp['startDate'] = 'Start Date should be less than end date';
        temp['endDate'] = 'End Date should be greater than start date';
    }
    if (startDate !== null && startDate < dayjs().startOf('day')) {
        temp['startDate'] = 'Start Date cannot be less than today';
    }
    if (endDate !== null && endDate < dayjs().startOf('day')) {
        temp['endDate'] = 'End Date cannot be less than today';
    }
    return temp;
}

/**
 * this function gives market start date
 * @param newRes 
 */
function getMarketStartDate(){
    const {dateStartEnd} = store.getState()?.manageCoupons?.data.recurrence;
    const startDate = dayjs(dateStartEnd.startDate);
    const now = dayjs();
    const DateToConsider = now.isAfter(startDate)?now:startDate;
    return DateToConsider.format("YYYY-MM-DDTHH:mm:ss.SSSZ");
}

/**
 * this function gives market end date
 * @param newRes 
 */
function getMarketEndDate(){
    const {nDaysFromActivation,dateStartEnd} = store.getState()?.manageCoupons?.data.recurrence;
    const startDate = dayjs(dateStartEnd.startDate);
    const now = dayjs();
    const DateToConsider = now.isAfter(startDate)?now:startDate;
    return dayjs(DateToConsider).add(nDaysFromActivation, 'day').format("YYYY-MM-DDTHH:mm:ss.SSSZ");
}

function getExtendedAttributes(schemeBodyCopy: requeestBodyType): any {
    const { dateStartEnd,isActivePeriodSaved,nDaysFromActivation} = store.getState()?.manageCoupons?.data.recurrence ?? {};
    const { isOverAndAbove, isPeriodWelcome, schemeOutletBifurcationsList, schemeLocationBifurcationsList, skipMarketSelection } = store.getState()?.manageCoupons?.data ?? {};
    let extAttr: { [key: string]: any } = {};
    if (nDaysFromActivation) {
        extAttr.marketStartDate = getMarketStartDate();
        extAttr.marketEndDate = getMarketEndDate();
    }
    if (skipMarketSelection !== undefined && !skipMarketSelection && !isVersionV1()) {
        extAttr.outletBifurcationsData = schemeOutletBifurcationsList;
        extAttr.locationBifurcationsData = schemeLocationBifurcationsList;
    }
    if (isOverAndAbove) {
        extAttr.OAAC = true;
    }
    if (isPeriodWelcome && schemeBodyCopy.criteria === "totalOrder_welcome") {
        extAttr.isWTOCL = true;
        extAttr.sd = convertPeriodToDate(dateStartEnd?.startDate);
        extAttr.ed = convertPeriodToDate(dateStartEnd?.endDate);
    }
    if (isActivePeriodSaved && nDaysFromActivation.trim() !== "") {
        extAttr.nd = nDaysFromActivation
    }

    // add extended attribute for mustbuy based on config
    if (schemeBodyCopy.schemeCalculation.schemeMustBuyGroupList.length > 0 && isMustBuyGroupCondition()) {
        extAttr.mustBuyWithAndCondition = 1
    }
    return extAttr;
}

function convertPeriodToDate(date: string): string {
    const parsedDate = new Date(date);
    const utcDateString = parsedDate.toISOString();
    return utcDateString;
}




export const isOnlyDigit = (inputValue: string) => {
    return /^\d*$/.test(inputValue);
}

export const isDecimal = (inputValue: string) => {
    return /^(\d+(\.\d{0,2})?)$/.test(inputValue);
}
export async function isNewPromoEnabledForLob(): Promise<boolean> {
    try {
        const res = await getMetaDataConfig("couponPortal", "isNewPromoEnabled");
        return res?.domainValues?.[0]?.isNewPromoEnabled === "true";
    } catch (e) {
        console.error("Error fetching promo config:", e);
        return false;
    }
}
